import { useNavigate } from "react-router-dom";
import { sendCommentEmail } from "../api/AuthenticationServices";
import "../assets/styles/Contact.css";
import { useState } from "react";
import FAQ from "./FAQPage";
const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [phone, setPhone] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };
  const navigate = useNavigate();
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name: name,
      email: email,
      phoneNum: phone,
      comment: comment,
    };
    console.log("Data ", data);
    try {
      const res = await sendCommentEmail(data);
      if (res.data.status === "success") {
        // console.log("Inside Successs");
        alert(
          res.data.message +
            " to academy. Reply mail will be sent soon to you from academy"
        );
        navigate("/");
      } else {
        if (res.data.status === "failed") {
          // console.log("Inside Successs");
          alert(res.data.message + " to academy. ");
        }
      }
    } catch (e) {
      alert(e);
    }
  };
  return (
    <fragment>
      <section className="contact">
        <div className="contact-heading">
          <h2>Contact Us</h2>
        </div>
        <div className="container">
          <div className="row">
            <div className="column">
              <div className="contact-widget">
                <div className="contact-widget-item">
                  <div className="icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div className="text">
                    <h5>Address</h5>
                    <p>
                      Erode-Chennimalai Rd, opposite to Indian oil Petrol Bunk,
                      near Erode Arts College and Indian Public School,
                      Senathipathipalayam, Erode, Tamil Nadu 638112
                    </p>
                  </div>
                </div>

                <div className="contact-widget-item">
                  <div className="icon">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div className="text">
                    <h5>Contact Us</h5>
                    <p>+91 99947 55567 | +91 99527 84664</p>
                  </div>
                </div>

                <div className="contact-widget-item">
                  <div className="icon">
                    <i className="fa-regular fa-envelope"></i>
                  </div>
                  <div className="text mail-text">
                    <h5>Mail</h5>
                    <p>littlechampfootballacademy@gmail.com </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="column">
              <div className="contact-form">
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={handleNameChange}
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={handleEmailChange}
                    required
                  />
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    value={phone}
                    pattern="[0-9]{10}"
                    onChange={handlePhoneChange}
                    required
                  />
                  <textarea
                    value={comment}
                    onChange={handleCommentChange}
                    placeholder="Comment"
                    required
                  ></textarea>
                  <button type="submit" className="site-btn">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
          {/* <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <Button variant="contained" component={RouterLink} to="/faq">
              Go to FAQs
            </Button>
          </div> */}
          <div className="row">
            <div className="map-column">
              <div className="contact-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3912.496402975483!2d77.69204731430548!3d11.298382191968589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96f8a585f1335%3A0x4427b6f22dc90c5b!2sLittle%20Champ%20Football%20Academy!5e0!3m2!1sen!2sin!4v1675950317760!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  title="Little Champ"
                  style={{ border: 0 }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FAQ />
    </fragment>
  );
};
export default Contact;
